import React, { Fragment, ComponentProps, useState } from 'react'
import { Box, Button } from '@mui/material'
import SelectFolderDialog from 'app/components/SelectFolderDialog'
import { FolderName, Record } from 'app/components'

interface Props
  extends Omit<ComponentProps<typeof SelectFolderDialog>, 'open' | 'onClose'> {}

const EditFolderButton = (props: Props) => {
  const [open, setOpen] = useState(false)
  return (
    <Fragment>
      <Button
        variant="contained"
        color={'primary'}
        className={'text-white'}
        onClick={() => setOpen(true)}
      >
        Edit Folder
      </Button>
      {open && (
        <SelectFolderDialog
          {...props}
          open={open}
          onClose={() => setOpen(false)}
        />
      )}
    </Fragment>
  )
}

export const FolderNameWithEditButton = (
  props: Props & { hideEditButton?: boolean }
) => {
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'space-between'}
      mb={2}
    >
      <Record
        label={'Folder'}
        value={
          <FolderName
            objectType={props.objectType}
            objectId={props.object.id}
          />
        }
      />
      {!props.hideEditButton && (
        <EditFolderButton objectType={props.objectType} object={props.object} />
      )}
    </Box>
  )
}

export default EditFolderButton
